import { observable, action } from 'mobx';
import _ from 'lodash';
import { Client } from '../models/Client';
import { ClientStore } from './client-store';
import { LoadingStore } from './loading-store';

export class ClientEntryStore {
  @observable clients: Client[];
  @observable currentClient: Client;
  @observable expandAddClient: boolean = true;

  constructor(private clientStore: ClientStore, private loadingStore: LoadingStore) {
    this.resetCurrentClient();
  }

  @action loadCurrentClients(): Promise<Client[]> {
    this.loadingStore.appIsBusy();
    return this.clientStore.loadCurrentClients().then((clients) => {
      this.clients = _.orderBy(clients, ['lastName', 'firstName', 'gender']);
      this.loadingStore.appIsNotBusy();
      return clients;
    }, (error: any) => {
      console.error(error);
      this.loadingStore.appIsNotBusy();
      return [];
    });
  }

  @action saveOrUpdate(): Promise<Client> {
    this.loadingStore.appIsBusy();
    const wasNew = this.currentClient.isNew();
    return this.clientStore.saveOrUpdate(this.currentClient).then(() => {
      // Handle the case of new vs existing client here....
      if (wasNew) {
        this.clients.unshift(this.currentClient);
      } else {
        // Replace client so it's reflected in the client display list
        const existingClient = Client.findClient(this.currentClient.id, this.clients);
        if (existingClient) {
          this.clients[this.clients.indexOf(existingClient)] = this.currentClient;
          // Create a new array so that the client display list will be updated
          this.clients = [...this.clients];
        }
      }
      
      this.resetCurrentClient();
      this.loadingStore.appIsNotBusy();
      return this.currentClient;
    }, (error: any) => {
      console.error(error);
      this.loadingStore.appIsNotBusy();
      return this.currentClient;
    }).catch((error) => {
      this.loadingStore.appIsNotBusy();
      return Promise.reject(error);
    });
  }

  @action resetCurrentClient() {
    console.log('RESETING CURRENT CLIENT ******************************************');
    this.setCurrentClient(new Client());
  }

  @action setCurrentClient(client: Client) {
    console.log('******************* setCurrentClient to:' + client.name);
    this.currentClient = client;
  }

  @action setExpandAddClient(expandAddClient: boolean) {
    this.expandAddClient = expandAddClient;
  }

  @action updateClientFields(client: Client): Promise<Client> {
    return this.clientStore.saveOrUpdate(client).then((savedClient) => {
      const existing = Client.findClient(savedClient.id, this.clients);
      if (existing) {
        this.clients[this.clients.indexOf(existing)] = savedClient;
        this.clients = [...this.clients];
      }
      return savedClient;
    }).catch((error) => {
      console.error(error);
      return Promise.reject(error);
    });
  }

  @action deleteClient(client: Client): Promise<any> {
    this.loadingStore.appIsBusy();
    return this.clientStore.deleteClient(client).then(() => {
      return this.loadCurrentClients();
    }).then(() => {
      this.loadingStore.appIsNotBusy();
    }).catch((error) => {
      console.error(error);
      this.loadingStore.appIsNotBusy();
    });
  }
}